export default [
	{
		text: "Invoice id",
		value: "customer_id"
	},
	{
		text: "Customer",
		value: "name"
	},
	{
		text: "Amount",
		value: "amount"
	},
	{
		text: "Email",
		value: "email"
	},
	{
		text: "Send sms",
		value: "send_sms"
	},
	{
		text: "Invoice",
		value: "file"
	},
	{
		text: "Dispatch report",
		value: "file_report"
	},
	{
		text: "Safety report",
		value: "file_report_safety"
	},
	{
		text: "Billing report",
		value: "file_report_billing"
	},
];
